<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/content" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Create Section</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex xs12 sm11 md10 lg9>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex class="px-2 pb-2" xs12 md7>
          <v-text-field
            label="Section Name"
            v-model.trim="newSection.name"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12>
          <v-text-field
            label="Instructions"
            v-model.trim="newSection.instructions"
            rows="3"
            hide-details
            textarea
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12>
          <v-btn
            @click.native="canCreate"
            class="my-0"
            color="success"
            :loading="creating"
            :disabled="creating"
            large
          >Create</v-btn>
          <v-btn @click.native="popup.type = 'Resetting', popup.show = true" class="my-0" color="error" large flat>
            <b>Reset</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-content-popup
    :popup="popup"
    :section-data="newSection"
  ></r-content-popup>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import ContentPopup from './ContentPopup.vue'
import {contentEvent} from '../../main'
export default {
  components: {
    rContentPopup: ContentPopup,
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    creating: false,
    sections: [],
    newSection: {},
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    contentEvent.$on('reset', () => {
      this.resetNewSection()
    })
    contentEvent.$on('createSection', () => {
      this.createSection()
    })
  },
  methods: {
    load () {
      this.loading = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      this.sections = this.$store.getters.sectionByContent(contentData.key)
      this.resetNewSection()
      this.loading = false
    },
    resetNewSection () {
      this.newSection = {
        name: '',
        url: '',
        instructions: ''
      }
    },
    canCreate () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newSection.name === '') {
        appMsg.msg = 'Please enter a name for the section'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newSection.name.toLowerCase() === 'create') {
        appMsg.msg = 'Please use a different name; that name is reserved.'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newSection.instructions === '') {
        appMsg.msg = 'Please enter instructions for the section'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      for (let s of this.sections) {
        if (this.newSection.name.toLowerCase() === s.name.toLowerCase()) {
          appMsg.msg = 'That section name already exists in this content'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
      }
      this.popup = {
        show: true,
        type: 'Creating Section'
      }
    },
    createSection () {
      this.creating = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      this.newSection.url = this.$store.getters.formatUrl(this.newSection.name)
      this.newSection.contentKey = contentData.key
      this.$store.dispatch('createSection', this.newSection).then(s => {
        const appMsg = {
          type: 'success',
          msg: s.name + ' created!'
        }
        this.creating = false
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/content/' + contentData.url + '/' + this.newSection.url)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.creating = false
        this.$store.dispatch('showAppMsg', appMsg)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/CreateSection.vue